interface Props {
  canonical: string;
}

export default function Canonical({ canonical }: Props) {
  return <link rel="canonical" href={canonical} />;
}
